<template>
    <div class="thumbnail-gallery carousel" v-if="slides">
        <agile class="agile__thumbnails" ref="agile__thumbnails" :options="options"
               :as-nav-for="asNavFor">
            <div class="slide slide--thumbnail" v-for="(slide, index) in slides" :key="index"
                 :class="`slide--${index}`" @click="$refs.agile__thumbnails.goTo(index)">
                <a class="" :href="slide"><img :src="slide"/></a>
            </div>
            <template slot="prevButton"><img src="/img/icons/arrow-left.svg" alt=""/></template>
            <template slot="nextButton"><img src="/img/icons/arrow-right.svg" alt=""/></template>
        </agile>
    </div>
</template>

<script>
    import {VueAgile} from 'vue-agile';
    import baguetteBox from 'baguettebox.js';


    export default {
        name: "CatUxoThumbnailGallery",
        components: {
            agile: VueAgile,
        },
        props: {
            files: {
                type: Array,
                default: [],
                required: true
            }
        },
        data() {
            return {
                asNavFor: [],
                options: {
                    autoplay: false,
                    centerMode: false,
                    infinite: false,
                    dots: false,
                    slidesToShow: 3,
                    navButtons: true,
                    responsive: [
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 4,
                            }
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 6,
                            }
                        }
                    ]
                },
            }
        },
        computed: {
            slides() {
                let files = this.files.filter(file => file.filetype === 'image/jpg' ||
                    file.filetype === 'image/jpeg' ||
                    file.filetype === 'image/png' ||
                    file.filetype === 'image/gif' ||
                    file.filetype === 'image/webp'
                );
                let slides = [];
                files.forEach(file => slides.push(file.aws_url));

                return slides;
            },
        },
        mounted() {
            this.asNavFor.push(this.$refs.agile__thumbnails);

            baguetteBox.run('.thumbnail-gallery', {
                overlayBackgroundColor: 'rgba(0,0,0,0.2)'
            });
        }
    }
</script>

<style lang="scss">
    .slide--thumbnail img {
        max-width: rem(200px);
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/shared/ThumbnailGallery.vue